export { default as StrongLabeledContentWithIcon } from './strong-labeled-content-with-icon';
